import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectors as arcCategoriesSelectors } from 'domains/arcCategories'
import ArcCategoriesComponent from './ArcCategoriesComponent'
import useAction from 'utils/useAction'
import * as arcCategoriesActions from 'actions/views/arcCategories'

const ArcCategories = () => {
  const categories = useSelector(arcCategoriesSelectors.getArcCategories)
  const isLoaded = useSelector(arcCategoriesSelectors.getIsLoaded)
  const isSaving = useSelector(arcCategoriesSelectors.getIsSavingActive)

  const fetchCategories = useAction(arcCategoriesActions.fetchArcCategories)

  useEffect(() => {
    if (!isLoaded) {
      fetchCategories()
    }
  }, [isLoaded, fetchCategories])

  return (
    <ArcCategoriesComponent
      categories={categories}
      isLoaded={isLoaded}
      isSaving={isSaving}
      onRefresh={fetchCategories}
    />
  )
}

export default ArcCategories